import { Lockup } from '@/brand/components/Lockup';

export function ComingSoonPage() {
  return (
    <div className="relative min-h-screen bg-midnight flex flex-col items-center justify-center overflow-hidden px-6">
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background: 'conic-gradient(from 180deg at 50% 40%, rgba(123,120,201,0.08) 0deg, rgba(70,110,168,0.06) 120deg, rgba(0,172,154,0.08) 240deg, rgba(123,120,201,0.08) 360deg)',
        }}
      />

      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background: 'radial-gradient(ellipse 60% 50% at 50% 45%, rgba(81,182,150,0.04) 0%, transparent 70%)',
        }}
      />

      <div className="relative z-10 flex flex-col items-center text-center max-w-2xl w-full">
        <Lockup className="h-20 sm:h-24 md:h-28 mb-16" />

        <h1 className="font-display text-[36px] sm:text-[48px] md:text-[56px] leading-[1.05] tracking-tight font-bold text-white mb-6">
          <span className="text-grad-motion-dark uppercase">Bridging Made Easy</span>
          <br />
          <span className="text-white/80 text-[0.6em] font-medium tracking-normal">through our platform</span>
        </h1>

        <p className="text-lg sm:text-xl text-onDark-soft max-w-md leading-relaxed mb-10">
          We share 50% of our broker commission with you — on every deal.
        </p>

        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-pill border border-onDark-line bg-white/[0.04]">
          <span className="w-2 h-2 rounded-full bg-mint-400 animate-pulse-soft" />
          <span className="text-sm font-medium text-onDark-soft tracking-wide uppercase">Coming Soon</span>
        </div>
      </div>

      <footer className="absolute bottom-0 left-0 right-0 py-6 px-6 flex items-center justify-center">
        <p className="text-xs text-onDark-micro">
          &copy; 2026 Lendaris
        </p>
      </footer>
    </div>
  );
}
